import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../Context/GlobalState";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { FaUser } from "react-icons/fa";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
import { twoDecimalPlaces } from "../utils/utilFuctions";
import { useNavigate } from "react-router-dom";
import "../index.css";
import "../App.css";
import { basicAuth } from "../utils/Credentials";

const getCleanValue = (value) => {
  const normalized = value?.toString().trim();
  if (!normalized || normalized === "undefined" || normalized === "null") {
    return "";
  }
  return normalized;
};

const getProjectToken = (item = {}) =>
  getCleanValue(item.p_token) ||
  getCleanValue(item.project_token) ||
  getCleanValue(item.projectToken) ||
  getCleanValue(item.ptoken) ||
  getCleanValue(item.token);

const Navbar = () => {
  const {
    siteid,
    setsiteid,
    siteurl,
    setURL,
    siteObj,
    Productname,
    setProductname,
    setIsVerified,
    setTransactionLoaderState,
    setsiteObj,
    setUserDetail,
    clearUserInfo,
  } = useContext(GlobalContext);
 
  const navigate = useNavigate();
  const { password, username } = basicAuth;
  const base64Credentials = btoa(`${username}:${password}`);
  const { user } = useContext(GlobalContext);
  const [selectedURL, setSelectedURL] = useState({
    label: siteObj?.label || "Select Url",
    value: siteObj?.value || "Select Url",
    id: siteObj?.id || siteObj?.p_token || siteid || "",
    p_token: siteObj?.p_token || siteObj?.id || siteid || "",
    project_name: siteObj?.project_name || Productname || "",
    is_verified: siteObj?.is_verified || "",
  });
  const [urlOptions, setUrlOptions] = useState([]);
  // function toggleOffcanvas() {
  //   document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  // }
  function logOut() {
    clearUserInfo();
    navigate("/", { replace: true });
  }

  const handleSelectChange = (selectedOption) => {
    const selectedProjectToken =
      getCleanValue(selectedOption.p_token) ||
      getCleanValue(selectedOption.project_token) ||
      getCleanValue(selectedOption.id);

    setsiteid(selectedProjectToken);
    setURL(selectedOption.value);
    setProductname(selectedOption.project_name);
    setsiteObj(selectedOption);
    setSelectedURL(selectedOption);
    sessionStorage.setItem("selectedURL", selectedOption.value);
    sessionStorage.setItem("selectedURLId", selectedProjectToken);
    sessionStorage.setItem("selectedURLLabel", selectedOption.label);
    sessionStorage.setItem(
      "selectedURLProjectName",
      selectedOption.project_name
    );
    if (selectedOption.is_verified === "N") {
      setIsVerified(false);
    } else {
      setIsVerified(true);
    }
  };

  const Getsitemapurl = async () => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({ token: user.token_login  }),
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/UserInfo/GenerateUserAccessManagement`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {

        const options = data.result.map((item) => {
          const projectToken = getProjectToken(item);

          return {
            value: item.site_url,
            label: `${item.site_url} `,
            id: projectToken,
            p_token: projectToken,
            project_token: projectToken,
            project_id: item.project_id,
            project_name: item.project_name,
            is_verified: item.is_verified,
          };
        });
        setUrlOptions(options);

        const selectedSiteUrl =
          getCleanValue(siteurl) ||
          getCleanValue(sessionStorage.getItem("selectedURL"));
        const selectedOption = options.find(
          (option) => option.value === selectedSiteUrl
        );

        if (selectedOption?.p_token && !getCleanValue(siteid)) {
          setsiteid(selectedOption.p_token);
          setsiteObj(selectedOption);
          setSelectedURL(selectedOption);
          sessionStorage.setItem("selectedURLId", selectedOption.p_token);
        }
      }
    } catch (error) {
    }
  };

  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "14rem",
    }),
    control: (provided) => ({
      ...provided,
      boxShadow: "none",
      borderRadius: ".4rem",
      width: "13rem",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#f0f0f0" : "#fff",
      color: state.isSelected ? "#000" : "#000",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#999",
    }),
  };
  const [balance, setbalance] = useState([]);
  const GetUserDetails = async () => {
    setTransactionLoaderState(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({ userid: user.user_id }),
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/UserInfo/GetUserDetails`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && data.data.length > 0) {
        setUserDetail(data.data[0]);
        sessionStorage.setItem("userdetail", JSON.stringify(data.data[0]));
      } else {
      }
    } catch (error) {
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const GetWalletInfo = async (e) => {
    setTransactionLoaderState(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({
          userid: user.user_id,
        }),
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/UserInfo/GetWalletInfo`,
        requestOptions
      );
      const data = await res.json();
      if (data?.status === "0") {
        const amount = data.data[0]?.amount;
        setbalance(amount);
        setTransactionLoaderState(false);
      } else {
        setTransactionLoaderState(false);
      }
    } catch (error) {
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    Getsitemapurl();
    GetUserDetails();
    GetWalletInfo();
  }, [user]);
  useEffect(() => {
    if (!user || user.user_type === "") {
      navigate("/");
    }
  }, [user]);

  if (!user || user.user_type === "") {
    return null;
  }

  return (
    <>
      <GlobalContext.Consumer>
        {(state) =>
          state.user == null || state.user.user_type === "" ? (
            navigate("/") || null
          ) : (
            <nav className="navbar fixed-top bg-white shadow-sm">
              <Container fluid>
                <Row className="w-100 align-items-center">
                  <Col xs={3} md={2} className="d-flex align-items-center">
                    <img
                      src={require("../seoimages/pnglogo.png")}
                      alt="Seobix"
                      style={{ width: "8rem" }}
                    />
                  </Col>

                  <Col
                    xs={6}
                    md={6}
                    className="d-flex align-items-center justify-content-end"
                  >
                    <span className="fw-bold text-dark">
                      Bix Bal : ₹{twoDecimalPlaces(balance)}
                    </span>
                    <i
                      className="mdi mdi-reload ms-2 cursor-pointer"
                      onClick={GetWalletInfo}
                    ></i>
                  </Col>

                  <Col
                    xs={4}
                    md={4}
                    className="d-flex justify-content-end align-items-center gap-2"
                  >
                    <span className="text-primary me-2">Select Project:</span>
                    <Select
                      options={urlOptions}
                      placeholder="Select URL"
                      value={selectedURL}
                      onChange={handleSelectChange}
                      styles={customStyles}
                    />

                    <Dropdown align="end">
                      <Dropdown.Toggle as="div" className="cursor-pointer">
                        {user.profile_url ? (
                          <img
                            className="rounded-circle border"
                            src={user.profile_url}
                            alt="profile"
                            width={40}
                            height={40}
                          />
                        ) : (
                          <FaUser size={24} className="text-primary" />
                        )}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="p-3">
                        <p className="mb-2 fw-bold">{user?.name}</p>
                        <p className="mb-1 small">{user?.email}</p>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={logOut}
                        >
                          Log Out
                        </Button>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </Row>
              </Container>
            </nav>
          )
        }
      </GlobalContext.Consumer>
    </>
  );
};

export default Navbar;
